<section>
  <div class="notice">
    <div>
      <h1 class="blind">UMMA</h1>
      <strong>404</strong>
      <p>Oops! something went wrong on our servers.</p>
      <!-- <a href="/home">GO HOME</a> -->
      <a href="/my">GO HOME</a>
    </div>
  </div>
  <div class="image">
    <img src="../../../../assets/images/img_umma_404.png" alt="UMMA" />
  </div>
</section>
